import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import config from "../../config";

export const getTransferServices = createAsyncThunk(
  "transfer/getTransferServices",
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetch(`${config.baseUrl}/transfer-services`);
      const data = await res.json();

      if (data.status !== "success") {
        return rejectWithValue(data.msg);
      }

      return data.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const deleteTransferService = createAsyncThunk(
  "transfer/deleteTransferService",
  async (id, { rejectWithValue }) => {
    try {
      const res = await fetch(`${config.baseUrl}/transfer-services/${id}`, {
        method: "DELETE",
      });

      const data = await res.json();

      if (data.status !== "success") {
        return rejectWithValue(data.msg);
      }

      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

const transferSlice = createSlice({
  name: "transfer",
  initialState: {
    bookings: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // get
      .addCase(getTransferServices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTransferServices.fulfilled, (state, action) => {
        state.loading = false;
        state.bookings = action.payload;
      })
      .addCase(getTransferServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // delete
      .addCase(deleteTransferService.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteTransferService.fulfilled, (state, action) => {
        state.loading = false;
        state.bookings = state.bookings.filter((b) => b.id !== action.payload);
      })
      .addCase(deleteTransferService.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default transferSlice.reducer;
